<template>
  <div class="dash-card discipline-breakdown-widget">
    <div class="dash-card-header">
      <h3 class="dash-card-title">
        <span
          class="dash-card-title-icon"
          style="background: #fff1f0; color: #f5222d"
        >
          <a-icon type="pie-chart" />
        </span>
        {{ $t("accueil.dashboard.disciplineBreakdown") }}
      </h3>
    </div>

    <div class="dash-card-body">
      <div v-if="total > 0" class="discipline-chart-wrap">
        <apexchart
          :options="chartOptions"
          :series="series"
          type="donut"
          height="240"
        />
        <div class="discipline-legend">
          <div
            v-for="(item, index) in breakdown"
            :key="item.punishmentTypeId || item.punishmentTypeName"
            class="discipline-legend-item"
          >
            <span
              class="discipline-legend-dot"
              :style="{ backgroundColor: colors[index % colors.length] }"
            />
            <span class="discipline-legend-label">{{
              item.punishmentTypeName
            }}</span>
            <span class="discipline-legend-value">{{ item.count }}</span>
          </div>
        </div>
      </div>
      <div v-else class="dash-empty-state">
        <div class="dash-empty-icon">
          <a-icon type="smile" />
        </div>
        <div>{{ $t("accueil.dashboard.noSanctions") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DisciplineBreakdownChart",
  props: {
    breakdown: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      colors: ["#fa8c16", "#f5222d", "#1890ff", "#722ed1", "#faad14", "#13c2c2"],
    };
  },
  computed: {
    total() {
      return this.breakdown.reduce((sum, item) => sum + (item.count || 0), 0);
    },
    series() {
      return this.breakdown.map((item) => item.count || 0);
    },
    chartOptions() {
      return {
        chart: { type: "donut" },
        labels: this.breakdown.map((item) => item.punishmentTypeName),
        colors: this.colors,
        legend: { show: false },
        dataLabels: {
          enabled: true,
          formatter: (val) => `${Number(val).toFixed(0)}%`,
          style: { fontSize: "11px", fontWeight: "bold" },
        },
        plotOptions: {
          pie: {
            donut: {
              size: "62%",
              labels: {
                show: true,
                total: {
                  show: true,
                  showAlways: true,
                  label: this.$t("accueil.dashboard.total"),
                  formatter: () => this.total,
                },
              },
            },
          },
        },
        tooltip: {
          y: {
            formatter: (val) => `${val} ${this.$t("accueil.dashboard.cases")}`,
          },
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.discipline-chart-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.discipline-legend {
  flex: 1;
  min-width: 160px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.discipline-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.discipline-legend-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
}

.discipline-legend-label {
  flex: 1;
  font-size: 0.78rem;
  color: #595959;
  font-weight: 500;
}

.discipline-legend-value {
  font-size: 0.82rem;
  font-weight: 700;
  color: #262626;
}
</style>
